import { useNavigate } from "react-router-dom";
import { Box, Tabs, Tab } from "@mui/material";
import React, { useEffect, useState } from "react";
import SearchBar from "../../components/SearchBar";
import CustomerSupportList from "../../features/manageCustomerSupport/customerSupportList";
import Pagination from "../../components/Panigation";
import { useLazyGetCustomerSupportQuery } from "../../services/customerSupport";
import { isValidInput } from "../../utils/validations";
import { CustomerSupport } from "../../types/General";
import IfCan from "../../components/IfCan";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const ManageCustomerSupport = () => {
  const navigate = useNavigate();

  

  const [isLoading, setIsLoading] = useState(false);
  const [getUser] = useLazyGetCustomerSupportQuery();
  const [totalCount, setTotalCount] = useState<number>(0);
  const [page, setPage] = useState(1);
  const [data, setData] = useState<CustomerSupport[]>([]);
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState<string>("");
  // const [userUpdate] = useUpdateUsersMutation();

  const [valueTabs, setValueTabs] = React.useState(0);
  const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs(newValue);
    setPage(1);
  };

  const [searchTerm, setSearchTerm] = useState("");

  const getUserList = async () => {
    setIsLoading(true);
    try {
      const response = await getUser({
        length: 10,
        type: valueTabs === 0 ? 1 : 2, // Assuming 1 is for pending and 2 for resolved
        start: page,
        search: debouncedSearchTerm,
      }).unwrap();
      if (response.status === 200) {
        setData(response?.data?.response_object || []);
        setTotalCount(response?.data?.total_records || 0);
      }
      setIsLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getUserList();
  }, [valueTabs, page, debouncedSearchTerm]);

  

  return (
    <>
      <div className="main_title">
        <h1>Manage Customer Support</h1>
        <p>
          <span onClick={() => navigate("/dashboard")}>Dashboard</span> - Manage
          Customer Support
        </p>
      </div>

      <div className="table_header">
        <div className="left_s">
          <Box className="custom_tabs1" sx={{ width: "100%" }}>
            <Tabs
              value={valueTabs}
              onChange={handleChangeTabs}
              aria-label="basic tabs example"
              className="custom_tabs_links"
            >
              <Tab label="Pending" {...a11yProps(0)} />
              <Tab label="Resolved" {...a11yProps(1)} />
            </Tabs>
          </Box>
        </div>
      </div>

      <div className="cards">
        <div className="table_header">
          <div className="left_s">
            <Box className="search_box">
              <SearchBar
                placeholder="Search..."
                searchTerm={searchTerm}
                setDebouncedSearchTerm={setDebouncedSearchTerm}
                value={searchTerm}
                onCross={() => setSearchTerm("")}
                onChange={(val: any) => {
                  if (isValidInput(val.target.value)) {
                    setSearchTerm(val.target.value);
                    setPage(1); // Reset to first page when searching
                  }
                }}
              />
            </Box>
          </div>
        </div>
        <CustomTabPanel value={valueTabs} index={0}>
          <CustomerSupportList
            status="pending"
            data={data}
            isLoading={isLoading}
            onSuccess={getUserList}
          />
        </CustomTabPanel>
        <CustomTabPanel value={valueTabs} index={1}>
          <CustomerSupportList
            status="resolved"
            data={data}
            isLoading={isLoading}
            onSuccess={getUserList}
          />
        </CustomTabPanel>

        {totalCount > 0 && (
          <div className="pagination_wrapper">
            <Pagination
              module={data}
              page={page}
              onPageChange={(newPage: number) => setPage(newPage)}
              totalPages={Math.ceil(totalCount / 10)}
              totalCount={totalCount}
              setPage={setPage}
            />
          </div>
        )}
      </div>
    </>
  );
};

export default ManageCustomerSupport;
